jQuery(function ($) {
    $(document).ready(function () {
        /**
         * How we create section accordion (window < 1280px)
         */
        if ($(".how-we-create-accordion").length > 0) {
            $('.how-we-create-accordion .accordion-content').click(function (e) {
                e.preventDefault();

                let $this = $(this);

                $('.how-we-create-accordion .active').each(function () {
                    if (! $(this).is($this)) {
                        $(this).children().last().slideUp(200);
                        $(this).children().last().addClass('hidden');
                        $(this).find('.icon-arrow-down').removeClass('rotate-180');
                        $(this).removeClass('active');
                    }
                });

                $this.children().last().slideToggle(200);
                $this.children().last().toggleClass('hidden');
                $this.find('.icon-arrow-down').toggleClass('rotate-180');
                $this.toggleClass('active');
            });
        }

        /**
         * How we create section tabs (window >= 1280px)
         */
        if ($(".how-we-create-tabs").length > 0) {
            const tabsContent = document.querySelectorAll('.how-we-create-tabs-container .tab-content');

            $('.how-we-create-tabs .tab').click(function (e) {
                e.preventDefault();

                let $this = $(this);

                $('.how-we-create-tabs .tab').each(function () {
                    if (! $(this).is($this)) {
                        $(this).removeClass('active').removeClass('underline').removeClass('text-verdilabblack');
                    }
                });

                $this.addClass('active').addClass('underline').addClass('text-verdilabblack');

                tabsContent.forEach(elem => elem.classList.add('opacity-0'));

                setTimeout(changeDisplay($this.index()), 300);
                setTimeout(changeOpacity($this.index()), 350);
            });

            function changeDisplay(index) {
                tabsContent.forEach(elem => {
                    elem.classList.add('invisible', 'h-0', 'w-0');
                    elem.classList.remove('h-fit', 'w-full')
                });

                tabsContent[index].classList.remove('invisible', 'h-0', 'w-0');
                tabsContent[index].classList.add('h-fit', 'w-full');
            }

            function changeOpacity(index) {
                tabsContent[index].classList.remove('opacity-0');
            }
        }
    });
});
